import { format } from 'date-fns';

export const statusLabels = {
  scheduled: 'Scheduled', publishing: 'Publishing', published: 'Published', draft: 'Draft',
  draft_uploaded: 'In TikTok drafts', failed: 'Failed', cancelled: 'Cancelled',
};
export const statusColors = {
  scheduled: '#fbbf24', publishing: '#60a5fa', published: '#34d399', draft: '#a1a1aa',
  draft_uploaded: '#fb923c', failed: '#f87171', cancelled: '#71717a',
};
export const dayKey = date => format(date, 'yyyy-MM-dd');
export const monthKey = date => format(date, 'yyyy-MM');
export const monthRange = date => ({
  start: new Date(date.getFullYear(), date.getMonth(), 1).toISOString(),
  end: new Date(date.getFullYear(), date.getMonth() + 1, 1).toISOString(),
});
export const dayRange = date => ({
  start: new Date(date.getFullYear(), date.getMonth(), date.getDate()).toISOString(),
  end: new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1).toISOString(),
});
export const queryString = values => new URLSearchParams(Object.fromEntries(
  Object.entries(values).filter(([, value]) => value !== 'all' && value != null),
)).toString();